import React, { useState, useEffect, useRef } from 'react'
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css'

// Local Styles
import {
  Wrapper,
  CarouselImage,
  Arrow,
  CarouselContainer,
  CarouselHeader,
  CarouselFooter,
  IndicatorItem,
  IndicatorList,
  CloseCarouselBtn,
  ActionButton,
  SwiperContainer,
  SwiperSlide,
  ArrowsContainer,
  SliderItem,
  SliderArrow,
  GridViewIcon,
  ToggleGridButton,
  PaginationDots,
  ContentWrapper,
} from './styles'

// Global styles
import { Container } from '../../styles/global'

// Icons
import PrevIcon from '../../images/ic-left-angle.svg'
import NextIcon from '../../images/ic-right-angle.svg'

const Indicators = ({ images, active }) => (
  <IndicatorList>
    {images.map((img, i) => (
      <IndicatorItem active={i === active} key={i} />
    ))}
  </IndicatorList>
)

const BackButton = ({ clickHandler }) => (
  <ActionButton onClick={clickHandler}>
    <PrevIcon />
  </ActionButton>
)

const NextButton = ({ clickHandler }) => (
  <ActionButton onClick={clickHandler}>
    <NextIcon />
  </ActionButton>
)

const MyCarousel = ({ images, exitZoomHandler, selected }) => {
  const [activeSlide, setActiveSlide] = useState(1);
  const swiper = useRef(null)
  
  useEffect(() => {
    swiper.current = new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 1,
      keyboard: true,
      initialSlide: selected,
      on: {
        slideChange: function () {
          setActiveSlide(this.realIndex + 1)
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      bulletClass: 'pagination-bullet',
      bulletActiveClass: 'pagination-bullet--active',
      breakpoints: {
        768: {
          pagination: false,
        }
      },
    })
    setActiveSlide(selected + 1);
  },[])
  
  const nextSlideHandler = () => {
    var mySwiper = document.querySelector('.swiper-container').swiper
    
    mySwiper.slideNext();
  }

  const prevSlideHandler = () => {
    var mySwiper = document.querySelector('.swiper-container').swiper

    mySwiper.slidePrev();
  }


  return (
    <ContentWrapper>
      <CarouselContainer className="swiper-container">
          <div className="swiper-wrapper" style={{ transformStyle: 'flat' }}>
          {images.map(image => (
            <SliderItem className="swiper-slide" style={{ transformStyle: 'flat' }}>
              <CarouselImage src={image.image} alt={image.altText} />
            </SliderItem>
          ))}

          </div>

          <PaginationDots className="swiper-pagination"></PaginationDots>

          <ArrowsContainer>
            <SliderArrow onClick={prevSlideHandler}><PrevIcon /></SliderArrow>
            <SliderArrow onClick={nextSlideHandler}><NextIcon /></SliderArrow>
          </ArrowsContainer>
      </CarouselContainer>
    </ContentWrapper>
  )
}

const CustomSlider = ({ images, selected = 0, exitZoomHandler }) => (
  <Wrapper>
    {/* <Container> */}
      <MyCarousel images={images} selected={selected} exitZoomHandler={exitZoomHandler} />
    {/* </Container> */}
  </Wrapper>
)

export default CustomSlider
